module.exports = __webpack_public_path__ + "img/sk_hyunwoo_23.e62bbba7.jpg";